import React, { Component } from "react";
import { connect } from "react-redux";
import DOMPurify from "dompurify";
import Header from "../components/comunes/Header";
import Footer from "../components/comunes/Footer";
import { Auth, Hub } from "aws-amplify";
import InputText from "../components/formulario/InputText";
// import imgLogin from '../resource/svg/bkg-login.svg';
import Utils from "../utils/Validate";
import ModalGenerico from "../components/comunes/ModalGenerico";
import Loading from "../components/comunes/Loading";
import { CONSTANTES } from "../utils/Constantes";
import {
  LOGIN as loginActions,
  USUARIO as guardarUsuarioActions,
  PASO_ACTUAL_F1 as actualizaPasoActualF1Actions,
  PASO_ACTUAL_F2 as actualizaPasoActualF2Actions,
  PASO_ACTUAL_F3 as actualizaPasoActualF3Actions,
  PASO_ACTUAL_F4 as actualizaPasoActualF4Actions,
  LOGOUT as logoutAction,
} from "../../service/actions";
import ChangePassword from "../components/ChangePassword";
import ResetPassword from "../components/ResetPassword";
import SubmitCode from "../components/SubmitCode";
import { callService as callServiceAction } from "../../service/commos/callService";
// import GTM from '../utils/GTM';
import moment from "moment";
import { obtenerRoles } from "../../service/actions";
import BotonOAuth from "../components/formulario/BotonOAuth";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import loginFederateLoading from '../resource/img/loginFederate.gif'

class Login extends Component {
  state = {
    mostrarModal: false,
    isLoading: false,
    m_modal: "",
    username: "",
    password: "",
    captcha: "",
    v_username: "",
    v_password: "",
    m_username: "",
    m_password: "",
    v_login: "",

    casoModal: "",

    documento: [
      {
        value: "1",
        detalle: "DNI",
      },
      {
        value: "2",
        detalle: "RUC",
      },
    ],

    ideDocumento: "1",
    dscDocumento: "DNI",
    v_ideDocumento: true,
    forLogin: true,
    forChange: false,
    loadingReset: false,
    forReset: false,
    hintPassword: false,
  };

  componentDidMount() {
    if ("true" !== localStorage.getItem("login")) {
      Auth.signOut();
    }
  }

  async componentWillMount() {
    await Hub.listen("auth", this.listenerAuth);

    await Auth.currentSession()
      .then((response) => {
        var exp = moment
          .unix(response.accessToken.payload.exp)
          .format("DD/MM/YYYY hh:mm:ss");
        var fecha_actual = moment(new Date()).format("DD/MM/YYYY hh:mm:ss");
        if (fecha_actual > exp) {
          Auth.signOut();
          this.props.history.push({ pathname: CONSTANTES.RUTA.login });
        } else {
          let mfaLogin = this.getLocalStorage("mfaLogin");
          if (mfaLogin === true) {
            this.obtenerFlujoPortalCobranzasLogged();
          } else {
            this.obtenerFlujoPortalCobranzas();
          }
        }
      })
      .catch((error) => {
        this.props.history.push({ pathname: CONSTANTES.RUTA.login });
      });
  }

  obtenerFlujoPortalCobranzas = () => {
    let location = this.getLocalStorage("location-search");
    let flujo = location.replace("?flujo=", "");
    this.setLocalStorage("FLUJO", flujo);
    if (localStorage.getItem("login") === "true") {
      this.props.history.push({ pathname: "/verifycode" });
      //this.props.history.push({ pathname: flujo.replace("#", "/") });
    } else {
      this.props.history.push({
        pathname: CONSTANTES.RUTA.login,
        search: location,
      });
    }
  };

  obtenerFlujoPortalCobranzasLogged = () => {
    let location = this.getLocalStorage("location-search");
    let flujo = location.replace("?flujo=", "");
    this.setLocalStorage("FLUJO", flujo);
    if (localStorage.getItem("login") === "true") {
      this.props.history.push({ pathname: flujo.replace("#", "/") });
    } else {
      this.props.history.push({
        pathname: CONSTANTES.RUTA.login,
        search: location,
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.usuario.indLogin &&
      nextProps.usuario.indLogin !== this.props.usuario.indLogin
    ) {
      localStorage.setItem("usuario", JSON.stringify(nextProps.usuario));
    }

    if (nextProps.usuario.indLogin !== this.props.usuario.indLogin) {
      this.props.actualizarLogin(nextProps.usuario.indLogin);
    }
  }

  setLocalStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  };

  getLocalStorage = (key) => {
    const local = localStorage.getItem(key);
    return JSON.parse(local);
  };

  removeLocalStorage = (key) => {
    localStorage.removeItem(key);
  };

  onChange = (e) => {
    let { value, name, minLength } = e.target;

    value = DOMPurify.sanitize(value);

    if ("ideDocumento" === name) {
      let ideDoc = value.split(CONSTANTES.SEPARADOR)[0];
      let dscDoc = value.split(CONSTANTES.SEPARADOR)[1];

      this.setState({
        ideDocumento: ideDoc,
        dscDocumento: dscDoc,
      });
    }

    if ("username" === name) {
      let val = Utils.validarUsername("Nro. de documento", value, minLength);

      this.setState(
        {
          ["v_" + name]: val.validate,
          ["m_" + name]: val.msj,
          [name]: value.split(/\s+/).join(""), //eliminamos los espacios en blanco
        },
        () => {
          this.validateLogin();
        }
      );
    }
    if ("password" === name) {
      let val = Utils.validarPass("Contraseña", value, minLength);

      this.setState(
        {
          ["v_" + name]: val.validate,
          ["m_" + name]: val.msj,
          [name]: value.split(/\s+/).join(""), //eliminamos los espacios en blanco
        },
        () => {
          this.validateLogin();
        }
      );
    }
  };

  validateLogin = () => {
    if (this.state.username !== "" && this.state.password !== "") {
      this.setState({ v_login: true });
    } else {
      this.setState({ v_login: false });
    }
  };

  mostrarLoading = (value) => {
    this.setState({ isLoading: value });
  };

  restablecerPassword = () => {
    Auth.forgotPassword(this.state.username)
      .then((data) => console.log(data))
      .catch((err) => console.log(err));
  };

  completarReseteoPassword = (params) => {
    // console.log(params);
    if (params.cancelar === true) {
      window.location.reload();
    } else {
      this.mostrarLoading(true);
      this.setState({ hintPassword: false });

      Auth.forgotPasswordSubmit(params.usuario, params.codigo, params.password)
        .then((response) => {
          // console.log(response);
          this.mostrarLoading(false);
          this.setState({
            username: params.usuario,
            password: params.password,
            forLogin: true,
            forChange: false,
            forReset: false,
            v_login: true,
          });
        })
        .catch((err) => {
          this.mostrarLoading(false);
          if ("UserNotConfirmedException" === err.code) {
            this.mostrarModal(
              "login",
              "Usuario requiere confirmación del registro antes de Loguear"
            );
          } else if ("PasswordResetRequiredException" === err.code) {
            this.mostrarModal("login", "Se requiere restablecer la contraseña");
          } else if ("NotAuthorizedException" === err.code) {
            this.setState({ hintPassword: true });
            this.mostrarModal("login", "Contraseña inválida");
          } else if ("UserNotFoundException" === err.code) {
            this.mostrarModal("login", "Usuario no existe");
          } else if ("InvalidPasswordException" === err.code) {
            this.setState({ hintPassword: true });
            this.mostrarModal("login", "El formato de contraseña es inválido.");
          } else {
            this.mostrarModal(
              "login",
              "Ocurrió un error al autenticar. Contacte al administrador"
            );
          }
        });
    }
  };

  completarNuevoPassword = (params) => {
    this.mostrarLoading(true);
    this.setState({ hintPassword: false });

    Auth.completeNewPassword(this.state.loginObj, params.password)
      .then((response) => {
        console.log("resppnse en completarNuevoPassword::::", response);
        this.mostrarLoading(false);

        // let userGroup = response.signInUserSession.accessToken.payload['cognito:groups'] ? response.signInUserSession.accessToken.payload['cognito:groups'][0] : '';

        // let custom = {
        //     username: response.username
        // }
        this.mostrarLoading(false);
        this.props
          .callService("GETROL", "rol", {}, obtenerRoles)
          .then((response) => {
            if (response && response.status && response.status === 200) {
              // this.props.guardarUsuario(custom);
              Auth.currentCredentials()
                .then((data) => {
                  console.log("data identity", data);
                  localStorage.setItem("identity", data.data.IdentityId);
                })
                .catch((err) => console.log(err));
              localStorage.setItem("login", true);
              // localStorage.setItem('fechaInicial', moment().subtract(3, 'months').format("YYYY-MM-DD"));
              localStorage.setItem(
                "fechaInicial",
                moment().format("YYYY-MM-DD")
              );
              localStorage.setItem("fechaFinal", moment().format("YYYY-MM-DD"));

              // GTM.registrar(GTM.CATEGORIA_LOGIN, 'Satisfactorio');
              let opciones = response.data.opciones;
              var reportediario;
              localStorage.setItem("permisos", JSON.stringify(opciones));

              let bancos =
                response.data.bancos != null ? response.data.bancos : "";
              localStorage.setItem("bancos", JSON.stringify(bancos));

              this.setLocalStorage(
                "location-search",
                "?flujo=" + !opciones.length > 0
                  ? "#blankpage"
                  : opciones[0].path.replace("/", "#")
              );

              this.obtenerFlujoPortalCobranzas();
            } else {
              this.mostrarModal(
                "login",
                "Usted no tiene acceso a este aplicativo"
              );
            }
          })
          .catch((err) => {
            console.log("ERROR ROL:", err);
            this.setState({
              forLogin: true,
              forChange: false,
              forReset: true,
              loginObj: "",
            });
            this.mostrarModal(
              "login",
              "No se configuró al usuario correctamente"
            );
          });
      })
      .catch((err) => {
        // console.error("XXX>")
        console.error(err);
        this.mostrarLoading(false);

        if ("UserNotConfirmedException" === err.code) {
          this.mostrarModal(
            "login",
            "Usuario requiere confirmación del registro antes de Loguear"
          );
        } else if ("PasswordResetRequiredException" === err.code) {
          this.mostrarModal("login", "Se requiere restablecer la contraseña");
        } else if ("NotAuthorizedException" === err.code) {
          this.setState({ hintPassword: true });
          this.mostrarModal("login", "Contraseña inválida");
        } else if ("UserNotFoundException" === err.code) {
          this.mostrarModal("login", "Usuario no existe");
        } else if ("InvalidPasswordException" === err.code) {
          this.setState({ hintPassword: true });
          this.mostrarModal("login", "El formato de contraseña es inválido.");
        } else if (
          "UserLambdaValidationException" === err.code &&
          err.message.includes("REINTENTAR")
        ) {
          this.completarNuevoPassword(params);
        } else {
          this.mostrarModal(
            "login",
            "Ocurrió un error al autenticar. Contacte al administrador"
          );
        }
      });
  };

  completarEnvioCodigo = (params) => {
    // console.log(params);
    if (params.cancelar === true) {
      window.location.reload();
    } else {
      // console.log("completar envio");
      // console.log(params);
      this.mostrarLoading(true);
      this.setState({ hintPassword: false });

      this.props
        .callService(
          "GETROL",
          "usuario",
          { username: params.usuario },
          obtenerRoles
        )
        .then((response) => {
          console.log("get ROL response", response);

          if (response.status == 200 && response.data) {
            let data = response.data;
            if (data.status == 1) {
              this.mostrarLoading(false);
              this.mostrarModal("mensaje", data.message);
            } else {
              Auth.forgotPassword(params.usuario)
                .then((response) => {
                  console.log(response);
                  this.mostrarLoading(false);
                  this.setState({
                    username: params.usuario,
                    forLogin: false,
                    forChange: false,
                    forReset: true,
                  });
                  this.mostrarModal(
                    "mensaje",
                    "El código fue generado y enviado con exito al correo: " +
                      response.CodeDeliveryDetails.Destination
                  );
                })
                .catch((err) => {
                  this.mostrarLoading(false);
                  // console.log(err);
                  if ("UserNotConfirmedException" === err.code) {
                    this.mostrarModal(
                      "login",
                      "Usuario requiere confirmación del registro antes de Loguear"
                    );
                  } else if ("PasswordResetRequiredException" === err.code) {
                    this.mostrarModal(
                      "login",
                      "Se requiere restablecer la contraseña"
                    );
                  } else if ("NotAuthorizedException" === err.code) {
                    this.setState({ hintPassword: true });
                    this.mostrarModal("login", "Contraseña inválida");
                  } else if ("UserNotFoundException" === err.code) {
                    this.mostrarModal("login", "Usuario no existe");
                  } else if ("InvalidPasswordException" === err.code) {
                    this.setState({ hintPassword: true });
                    this.mostrarModal(
                      "login",
                      "El formato de contraseña es inválido."
                    );
                  } else if ("LimitExceededException" === err.code) {
                    this.mostrarModal(
                      "login",
                      "Se ha excedido el límite de intentos, intente después de un tiempo."
                    );
                  } else {
                    this.mostrarModal(
                      "login",
                      "Ocurrió un error al autenticar. Contacte al administrador"
                    );
                  }
                });
            }
          }
        })
        .catch((err) => {
          console.log("ERROR ROL:", err);
          this.mostrarModal(
            "login",
            "Ocurrió un error comuniquesé con el administrador"
          );
        });
    }
  };

  enviarCodigo = () => {
    this.fetchGuestCredentials();
    this.setState({
      forLogin: false,
      forChange: false,
      forReset: false,
      loginObj: "",
    });
  };

  fetchGuestCredentials = async () => {
    const identityPoolId = process.env.REACT_APP_IDENTITYPOOLID;
    const region = process.env.REACT_APP_REGION;

    const requestPayload = {
      IdentityPoolId: identityPoolId,
    };

    this.setState({
      loadingReset: true,
    });

    try {
      const response = await fetch(
        `https://cognito-identity.${region}.amazonaws.com/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target": "AWSCognitoIdentityService.GetId",
          },
          body: JSON.stringify(requestPayload),
        }
      );

      const responseData = await response.json();
      const identityId = responseData.IdentityId;

      const credentialsPayload = {
        IdentityId: identityId,
      };

      const credentialsResponse = await fetch(
        `https://cognito-identity.${region}.amazonaws.com/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-amz-json-1.1",
            "X-Amz-Target":
              "AWSCognitoIdentityService.GetCredentialsForIdentity",
          },
          body: JSON.stringify(credentialsPayload),
        }
      );

      const credentialsData = await credentialsResponse.json();
      localStorage.setItem("credentialGuess", JSON.stringify(credentialsData));
    } catch (error) {
      console.error("Error obtaining guest credentials", error);
    }

    this.setState({
      loadingReset: false,
    });
  };

  doSubmit = () => {
    this.login();
  };

  login = () => {
    this.mostrarLoading(true);
    try {
      // console.error(Auth.currentSession());
      Auth.signIn({
        username: this.state.username.trim(),
        password: this.state.password.trim(),
        authFlow: "USER_PASSWORD_AUTH",
      })
        .then((response) => {
          console.log(response);
          if (response.challengeName === "NEW_PASSWORD_REQUIRED") {
            this.mostrarLoading(false);
            this.setState({
              forLogin: false,
              forChange: true,
              forReset: true,
              loginObj: response,
            });
            // const { requiredAttributes } = response.challengeParam;
          } else {
            this.mostrarLoading(false);
            this.props
              .callService("GETROL", "rol", {}, obtenerRoles)
              .then((response) => {
                if (response && response.status && response.status === 200) {
                  Auth.currentCredentials()
                    .then((data) => {
                      console.log("data identity", data);
                      localStorage.setItem("identity", data.data.IdentityId);
                    })
                    .catch((err) => console.log(err));
                  localStorage.setItem("login", true);
                  // localStorage.setItem('fechaInicial', moment().subtract(3, 'months').format("YYYY-MM-DD"));
                  localStorage.setItem(
                    "fechaInicial",
                    moment().format("YYYY-MM-DD")
                  );
                  localStorage.setItem(
                    "fechaFinal",
                    moment().format("YYYY-MM-DD")
                  );

                  // GTM.registrar(GTM.CATEGORIA_LOGIN, 'Satisfactorio');
                  let opciones = response.data.opciones;

                  var reportediario;
                  localStorage.setItem("permisos", JSON.stringify(opciones));

                  let bancos =
                    response.data.bancos != null ? response.data.bancos : "";
                  localStorage.setItem("bancos", JSON.stringify(bancos));

                  this.setLocalStorage(
                    "location-search",
                    "?flujo=" + !opciones.length > 0
                      ? "#blankpage"
                      : opciones[0].path.replace("/", "#")
                  );
                  this.obtenerFlujoPortalCobranzas();
                } else {
                  localStorage.clear();
                  this.mostrarModal(
                    "login",
                    "Usted no tiene acceso a este aplicativo"
                  );
                }
              })
              .catch((err) => {
                console.log("ERROR ROL:", err);
                this.mostrarModal(
                  "login",
                  "No se configuró al usuario correctamente"
                );
              });
          }
        })
        .catch((err) => {
          // console.error("XXX>")
          console.error("ERROR SIGN:", err);
          this.mostrarLoading(false);

          if ("UserNotConfirmedException" === err.code) {
            this.mostrarModal(
              "login",
              "Usuario requiere confirmación del registro antes de Loguear"
            );
          } else if ("PasswordResetRequiredException" === err.code) {
            // console.log(err);
            // this.mostrarModal('login','Se requiere restablecer la contraseña');
            this.setState({
              forLogin: false,
              forChange: false,
              forReset: true,
              loginObj: "",
            });
          } else if ("NotAuthorizedException" === err.code) {
            if (err.message.toLowerCase().includes("temporary password")) {
              this.mostrarModal(
                "login",
                "La clave temporal ha expirado, por favor comuniquesé con su adiministrador para resetear la clave y volver a intentar"
              );
            } else {
              this.mostrarModal(
                "login",
                "Los datos ingresados son incorrectos, por favor verifícalos y vuelve a intentar"
              );
            }
          } else if ("UserNotFoundException" === err.code) {
            this.mostrarModal(
              "login",
              "Los datos ingresados son incorrectos, por favor verifícalos y vuelve a intentar"
            );
          } else if ("InvalidPasswordException" === err.code) {
            this.mostrarModal("login", "El formato de contraseña es inválido.");
          } else if (
            "UserLambdaValidationException" === err.code &&
            err.message.includes("REINTENTAR")
          ) {
            this.login();
          } else {
            this.mostrarModal(
              "login",
              "Ocurrió un error al autenticar. Contacte al administrador"
            );
          }
        });
    } catch (err) {
      // console.error("XXX>")
      console.error(err);
      this.mostrarLoading(false);
      this.mostrarModal(
        "login",
        "Ocurrió un error al autenticar. Contacte al administrador"
      );
    }
  };

  mostrarModal = (casoModal, m_modal) => {
    this.setState({
      casoModal,
      m_modal,
      mostrarModal: true,
    });
  };

  onKeyDown = (e) => {
    if (13 === e.which && this.state.v_login === true) {
      this.login();
    }
  };

  listenerAuth = ({ payload: { event, data } }) => {
    switch (event) {
      case "signIn":
        //   this.mostrarLoading(true);
        this.getAuth();
        break;
      case "signOut":
        // console.log("Cerrar Sesion");
        //this.removeLocalStorage('loginFederate');
        this.getAuth();
        break;
      default:
        //this.removeLocalStorage('loginFederate');
        this.getAuth();
    }
  };

  getAuth = () => {
    Auth.currentSession()
      .then((res) => {
        this.props
          .callService("GETROL", "rol", {}, obtenerRoles)
          .then((response) => {
            if (response && response.status && response.status === 200) {
              Auth.currentCredentials()
                .then((data) => {
                  console.log("IdentityId", data);
                  localStorage.setItem("identity", data.IdentityId);
                })
                .catch((err) => console.log(err));
              localStorage.setItem("login", true);
              localStorage.setItem(
                "fechaInicial",
                moment().format("YYYY-MM-DD")
              );
              localStorage.setItem("fechaFinal", moment().format("YYYY-MM-DD"));
              // GTM.registrar(GTM.CATEGORIA_LOGIN, 'Satisfactorio');
              let opciones = response.data.opciones;
              var reportediario;
              localStorage.setItem("permisos", JSON.stringify(opciones));

              let bancos =
                response.data.bancos != null ? response.data.bancos : "";
              localStorage.setItem("bancos", JSON.stringify(bancos));

              this.setLocalStorage(
                "location-search",
                "?flujo=" + !opciones.length > 0
                  ? "#blankpage"
                  : opciones[0].path.replace("/", "#")
              );
              let mfaLogin = this.getLocalStorage("mfaLogin");
              if (mfaLogin === true) {
                this.obtenerFlujoPortalCobranzasLogged();
              } else {
                this.obtenerFlujoPortalCobranzas();
              }
            } else {
              // console.log("usted no tiene permisos");
              localStorage.clear();
              this.mostrarModal(
                "login",
                "Usted no tiene acceso a este aplicativo"
              );
            }
          })
          .catch((err) => {
            console.log("ERROR ROL:", err);
            this.mostrarModal(
              "login",
              "No se configuró al usuario correctamente"
            );
          });
      })
      .catch((e) => {
        this.props.history.push({ pathname: CONSTANTES.RUTA.login });
      });
  };

  render() {
    return (
      <>
        <Header />

        <div
          id="login"
          className="body body d-flex justify-content-center align-items-center "
          style={{ paddingBottom: 250 }}
        >
          <div className="contenedor-login d-flex justify-content-center scrollspy">
            <div className="boxContenedor-login d-flex mb-flex-column mb-align-items-start justify-content-between">
              <div className="mb-w100 w50 d-flex login-child form-login">
                {this.state.forLogin ? (
                  <div className="login">
                    <p className="welcome-ss">
                      Bienvenido a &nbsp;<span>COBRANZAS</span>
                    </p>
                    <Row>
                      <Col
                        className="s12 m10 l5"
                        style={{ marginBottom: "30px" }}
                      >
                        <BotonOAuth />
                      </Col>
                      <Col className="m1 onlydesk-block">
                        <hr
                          className="barraLogin"
                          style={{ height: "200px" }}
                        ></hr>
                      </Col>
                      <Col className="s12 onlymob-flex">
                        <hr
                          className="barraLogin"
                          style={{ width: "85%", height: "4px" }}
                        ></hr>
                      </Col>
                      {/* <div className="d-flex justify-content-center" >
                                <p className="guia-parrafo guia-rojo">OR</p>
                                </div> */}
                      <Col className="s12 m10 l6">
                        <div className="d-flex justify-content-center">
                          <InputText
                            name="username"
                            value={this.state.username}
                            placeholder="Usuario"
                            onChange={this.onChange}
                            onBlur={() => {}}
                            onKeyDown={this.onKeyDown}
                            // validate={this.state.v_username}
                            // minLength="8"
                            // maxLength="11"
                            origen="login"
                            mensaje={this.state.m_username}
                            type="text"
                          />
                        </div>
                        <div className="d-flex justify-content-center">
                          <InputText
                            name="password"
                            value={this.state.password}
                            placeholder="Contraseña"
                            onChange={this.onChange}
                            onBlur={() => {}}
                            onKeyDown={this.onKeyDown}
                            // validate={this.state.v_password}
                            minLength="8"
                            maxLength="50"
                            origen="login"
                            mensaje={this.state.m_password}
                            type="password"
                          />
                        </div>
                        <div style={{ textAlign: "right", padding: 10 }}>
                          <button
                            style={{
                              color: "red",
                              border: 0,
                              background: "white",
                            }}
                            className={"pointer"}
                            onClick={() => this.enviarCodigo()}
                            disabled={false}
                          >
                            {" "}
                            Restablecer Contraseña
                          </button>
                        </div>
                        <div className="input-button">
                          <button
                            id="btnLogin"
                            onClick={() => this.doSubmit()}
                            className={
                              this.state.v_login === true
                                ? "btn-login btn-small w100 no-box-shadow"
                                : "btn-login-inactive btn-small w100 no-box-shadow"
                            }
                          >
                            <span className="onlydesk-flex">
                              INGRESAR A MI CUENTA
                            </span>
                            <span className="onlymob-flex">INGRESAR</span>
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                ) : this.state.forChange ? (
                  <ChangePassword
                    {...this.state}
                    onClick={this.completarNuevoPassword}
                  />
                ) : this.state.forReset ? (
                  <ResetPassword
                    {...this.state}
                    onClick={this.completarReseteoPassword}
                  />
                ) : (
                  <SubmitCode
                    {...this.state}
                    onClick={this.completarEnvioCodigo}
                  />
                )}
              </div>
              {/* <div className='mb-display-none w50 d-flex justify-content-center align-items-center img-login'>
                            <img src={imgLogin} alt="" width="300" height="300"></img>
                        </div> */}
            </div>
          </div>
        </div>
        {this.state.isLoading ? <Loading /> : null}

        <ModalGenerico
          caso={this.state.casoModal}
          mostrar={this.state.mostrarModal}
          mensaje={this.state.m_modal}
          cerrarModal={() => this.setState({ mostrarModal: false })}
        />

        <Footer
          mostrarModal={this.mostrarModal}
          pageLogin={true}
          pageActivo={false}
        />
      </>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    usuario: store.usuario,
    pasos: store.pasos,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actualizarLogin: (isLogin) => dispatch(loginActions(isLogin)),
    guardarUsuario: (custom) => dispatch(guardarUsuarioActions(custom)),
    callService: (method, nameService, request, action) =>
      dispatch(callServiceAction(method, nameService, request, action)),
    logout: () => dispatch(logoutAction()),

    actualizaPasoActualF1: (paso) =>
      dispatch(actualizaPasoActualF1Actions(paso)),
    actualizaPasoActualF2: (paso) =>
      dispatch(actualizaPasoActualF2Actions(paso)),
    actualizaPasoActualF3: (paso) =>
      dispatch(actualizaPasoActualF3Actions(paso)),
    actualizaPasoActualF4: (paso) =>
      dispatch(actualizaPasoActualF4Actions(paso)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
